import { Placement } from 'react-joyride';
import { BaseTour } from '../types';
import { COMMONS } from './constants';

export class AuditDashboardTour extends BaseTour {
  id = 'audit-dashboard';
  content = 'Audit Dashboard Tour';
  placement: Placement = 'bottom';
  steps = {
    title: (serviceProvider: string, modality: string) => ({
      content: `Welcome to the audit details! Here you can see all invoices and shipments related to ${serviceProvider} for ${modality} modality that are waiting for user review.`,
    }),
    backButton: COMMONS.BACK_BUTTON,
    moreActions: (serviceProvider: string, modality: string) => ({
      content: `Access to other dashboards for ${serviceProvider} and ${modality} modality directly from here.`,
    }),
    co2Widget: () => ({
      content: 'This shows the total CO2 emissions associated with the displayed shipments.',
    }),
    currencyReference: COMMONS.CURRENCY_REFERENCE,
    dateReference: COMMONS.DATE_REFERENCE,
    metrics: COMMONS.METRICS,
    tabs: () => ({
      content: "The 'Action Needed' tab shows invoices requiring your attention, while 'All Exceptions' displays all items with pending actions.",
    }),
    columnSettings: () => ({
      content: 'Customize which columns you want to see in the table to suit your needs.',
    }),
    refresh: COMMONS.REFRESH,
    firstRowAction: () => ({
      content: 'Click here to dive into the details of the first item in the list.',
      placement: 'left' as Placement,
    }),
  } as const;
}
